import React from "react";
import { useParams } from "react-router-dom"; // Import useParams
import MasterLayout from "../masterLayout/MasterLayout";
import ComplainFormPageDispatchUpdate from "../components/ComplainFormPageDispatchUpdate";

const ComplainFormDispatchUpdate = () => {
    const { id } = useParams(); // Get the id from the URL parameters
  
  return (
    <div>
      <MasterLayout>
        <ComplainFormPageDispatchUpdate  complainId={id} />
      </MasterLayout>
    </div>
  );
};

export default ComplainFormDispatchUpdate;
